import portalApi from "../api/apiSlice";

const assignmentsApi = portalApi.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "assignments",
    }),

    getSingleAssignment: builder.query({
      query: (assignmentId) => `assignments/${assignmentId}`,
    }),

    addAssignment: builder.mutation({
      query: (assignment) => ({
        url: "assignments",
        method: "POST",
        body: assignment,
      }),

      onQueryStarted: async (assignment, { dispatch, queryFulfilled }) => {
        try {
          const response = await queryFulfilled;
          dispatch(
            portalApi.util.updateQueryData(
              "getAssignments",
              undefined,
              (prevAssignments) => {
                return [...prevAssignments, response.data];
              }
            )
          );
        } catch {}
      },
    }),

    editAssignment: builder.mutation({
      query: (assignment) => ({
        url: `assignments/${assignment.id}`,
        method: "PATCH",
        body: assignment,
      }),

      onQueryStarted: async (assignment, { dispatch, queryFulfilled }) => {
        try {
          const { data } = await queryFulfilled;

          dispatch(
            portalApi.util.updateQueryData(
              "getAssignments",
              undefined,
              (prevAssignments) => {
                return prevAssignments.map((prevAssignment) => {
                  if (prevAssignment.id === assignment.id) {
                    return data;
                  }
                  return prevAssignment;
                });
              }
            )
          );

          dispatch(
            portalApi.util.updateQueryData(
              "getSingleAssignment",
              assignment.id,
              () => {
                return data;
              }
            )
          );
        } catch {}
      },
    }),

    deleteAssignment: builder.mutation({
      query: (assignmentId) => ({
        url: `assignments/${assignmentId}`,
        method: "DELETE",
      }),

      onQueryStarted: async (assignmentId, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
          dispatch(
            portalApi.util.updateQueryData(
              "getAssignments",
              undefined,
              (prevAssignments) => {
                return prevAssignments.filter((prevAssignment) => {
                  return prevAssignment.id !== assignmentId;
                });
              }
            )
          );
        } catch {}
      },
    }),
  }),
});

export const {
  useGetAssignmentsQuery,
  useAddAssignmentMutation,
  useGetSingleAssignmentQuery,
  useEditAssignmentMutation,
  useDeleteAssignmentMutation,
} = assignmentsApi;
